import { Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import { makeStyles } from '@mui/styles';
import TablePaginationActions from '../../../../shared/components/Table/Actions';
import { dateFormat } from '../../../../util/DateUtil';

const useStyles = makeStyles({
    table: {
        minWidth: 650,
        whiteSpace: 'nowrap',
    },
    rowHeader: {
        fontSize: 13,
        fontWeight: '700',
    },
    title: {
        marginBottom: '20px',
        marginTop: '20px',
        backgroundColor: '#90EE90',
        borderRadius: '10px',
        padding: '20px'
    },
})

const IntegralPresencaAlunoUserTable = ({ listaPresencaAluno, handleChangePage }) => {
    const classes = useStyles();



    return (
        <>
            {listaPresencaAluno.totalElements > 0 ?
                <>
                    < Table className={classes.table} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.rowHeader}>Data</TableCell>
                                <TableCell className={classes.rowHeader}>Presença</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {listaPresencaAluno.content.map((presencaAluno) => (
                                <TableRow key={presencaAluno.codigo}>
                                    <TableCell>{dateFormat(presencaAluno.integralPresenca.data)}</TableCell>
                                    <TableCell>{presencaAluno.presente ? 'Presente' : 'Falta'}</TableCell>

                                </TableRow>

                            ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[]}
                        rowsPerPage={listaPresencaAluno.size ? listaPresencaAluno.size : 0}
                        component="div"
                        count={listaPresencaAluno.totalElements}
                        page={listaPresencaAluno.number}
                        onPageChange={handleChangePage}
                        labelDisplayedRows={({ from, to, count }) => (from + "-" + to + " de " + (count !== -1 ? count + " registros" : " mais de " + to))}
                        ActionsComponent={TablePaginationActions}
                    />
                </> :
                <Grid>
                    <Typography className={classes.title} variant="h6">
                        Nenhum Registro Cadastrado
                    </Typography>
                </Grid>
            }
        </>
    );
}

export default IntegralPresencaAlunoUserTable;